import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  name;
  email;
  subject;
  message;
  constructor(
    private toastr: ToastrService
  ) { }

  ngOnInit() {
  }
  onSubmit(form) {
    if (form.valid) {
      this.toastr.show("Thank you for contacting us!")
      form.reset();
    } else {
      this.toastr.error("Please enter a valid Name / Email")
    }
  }
}
